import React, { useState } from 'react';
import { orderBy, size, values, map } from 'lodash/fp';
import { Table } from 'rsuite';
import { useSelector } from 'react-redux';
import {
  getAll as getItemsAndPackagesSkus,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/items-and-packages-skus';
import PathKeyCell from '../../../widgets/custom-cell/PathKey';
import computeTableHeight from '../../../../helpers/computeTableHeight';
import HeaderCell from '../../../widgets/custom-cell/HeaderCell';
import ItemTypeCell from './ItemTypeCell';
import tableColumns from './columns';

const { Column } = Table;

export default function ItemsAndPackagesSkusList() {
  const [sort, setSort] = useState({ column: 'item.name', type: 'asc' });
  const searchResult = useSelector(getItemsAndPackagesSkus);
  const isFetching = useSelector(getIsFetching);

  const getColumns = () => {
    const resultColumns = values(tableColumns);
    return orderBy('order', 'asc', resultColumns);
  };

  const handleSortColumn = (column, type) => {
    setSort({ column, type });
  };

  const sortedData = orderBy(sort.column, sort.type, searchResult);
  return (
    <Table
      bordered
      cellBordered
      data={sortedData}
      loading={isFetching}
      sortColumn={sort.column}
      sortType={sort.type}
      onSortColumn={handleSortColumn}
      height={computeTableHeight(size(searchResult))}
    >
      {map(
        ({ dataKey, label, width }) => (
          <Column
            sortable
            key={`column-${dataKey}`}
            {...(width ? { width, resizable: true } : { flexGrow: 1 })}
          >
            <HeaderCell>{label}</HeaderCell>
            {dataKey === 'item.itemType' ? (
              <ItemTypeCell dataKey={dataKey} />
            ) : (
              <PathKeyCell dataKey={dataKey} />
            )}
          </Column>
        ),
        getColumns()
      )}
    </Table>
  );
}
